import { createTheme } from '@mui/material/styles';

export const theme = createTheme({
  palette: {
    primary: {
      main: '#4A6741', // Forest green
      light: '#6B8E64',
      dark: '#2C4A23',
    },
    secondary: {
      main: '#8B9D83', // Sage green
      light: '#A7B59E',
      dark: '#6F7D68',
    },
    background: {
      default: '#F5F7F2', // Light sage
      paper: '#FFFFFF',
    },
    text: {
      primary: '#2C3A28', // Dark forest green
      secondary: '#5C6B57', // Muted green
    },
  },
  typography: {
    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
    h1: {
      fontWeight: 500,
      color: '#2C3A28',
    },
    h2: {
      fontWeight: 500,
      color: '#2C3A28',
    },
    h3: {
      fontWeight: 500,
      color: '#2C3A28',
    },
    h4: {
      fontWeight: 500,
      color: '#2C3A28',
    },
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: 8,
          textTransform: 'none',
          padding: '8px 24px',
        },
        contained: {
          boxShadow: 'none',
          '&:hover': {
            boxShadow: 'none',
          },
        },
      },
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          backgroundColor: '#FFFFFF',
          borderRadius: 12,
        },
      },
    },
  },
}); 